/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import questionIcon from "../../../assets/icons/progress/icon_progressbar_frage.svg";
import idIcon from "../../../assets/icons/progress/icon_progressbar_personal_data.svg";
import documentsIcon from "../../../assets/icons/progress/icon_progressbar_vertrag_upload.svg";

const progressBarsteps = [
  {
    key: "description",
    name: "Mein Anliegen",
    icon: questionIcon,
  },
  {
    key: "documents",
    name: "Unterlagen",
    icon: documentsIcon,
  },
  {
    key: "personal",
    name: "Persönliche Angaben",
    icon: idIcon,
  },
];

export default progressBarsteps;
